import { render, staticRenderFns } from "./pricelist.vue?vue&type=template&id=d08cb1c4&"
import script from "./pricelist.vue?vue&type=script&lang=js&"
export * from "./pricelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d08cb1c4')) {
      api.createRecord('d08cb1c4', component.options)
    } else {
      api.reload('d08cb1c4', component.options)
    }
    module.hot.accept("./pricelist.vue?vue&type=template&id=d08cb1c4&", function () {
      api.rerender('d08cb1c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4WCkzjDt3JOCb/JS/comp/pricelist.vue"
export default component.exports